// extracted by mini-css-extract-plugin
export var image = "sectionLogos-module--image--9b777";
export var logo = "sectionLogos-module--logo--42534";
export var logos = "sectionLogos-module--logos--5f6e0";
export var section = "sectionLogos-module--section--adcc7";